package game.entity

import LobbyTrapController
import game.Game
import game.Room

class LobbyTrap: Entity() {
    override fun onCollideWithPlayer(game: Game, room: Room): Boolean {
        game.controller = LobbyTrapController()

        return true
    }
}